export default __webpack_public_path__ + "static/media/airbnb.4e322999.mp4";